/** Prompts in plain words (ADR-0064): versions, where they are used, preview, try, compare. */
export default {
  en: {
    intro: "Instructions your agents use. Every save is a new version; choose which version is used live, in testing or in a small trial.",
    select: "Prompt",
    create: "New prompt",
    cancel: "Cancel",
    newName: "New prompt name",
    createHelp: "Letters, digits, dots, hyphens and underscores. The first version is created when you save.",
    nameInvalid: "Use letters, digits, dots, hyphens and underscores (start with a letter or digit).",
    none: "No prompts yet. Create one to start.",
    libraryDown: "The prompt library isn't running right now, so prompts can't be shown or saved. Ask an operator to start it (Health and usage shows its state).",
    libraryDownTech: "What the system said",
    retry: "Try again",
    versions: "Versions",
    pick: "Select version {{version}}",
    pickVersion: "Version {{version}}",
    pickerName: "Prompt from the library",
    pickerVersion: "Which version",
    pickerRef: "Saved prompt reference",
    pickerDown: "The prompt library can't be reached right now. You can type the prompt's reference instead.",
    pickerNoVersion: "No version of this prompt is marked for that use. Choose another version.",
    pickerTakes: "What each value takes",
    pickerFor: "Value for {{name}}",
    pickerChoose: "Choose a value from earlier",
    pickerMissing: "Still needed",
    pickerPath: "Reads that value directly",
    version: "Version",
    usedIn: "Used in",
    whatChanged: "What changed?",
    whatChangedPlaceholder: "For example: answers now mention the policy section",
    when: "When",
    useIn: "Use version {{version}} in:",
    stageLabel: "Where to use it",
    use: "Use this version",
    used: "Version {{version}} is now used in {{stage}}",
    stageHelp: "Live: what customers get. Testing: what builders try. Trial: a small share of live traffic.",
    stage: { live: "Live", testing: "Testing", trial: "Trial" },
    editor: "Edit (from version {{version}})",
    firstVersion: "First version",
    template: "Instructions",
    variablesHelp: "Write {{name}} where a value goes, for example {{customer_name}}. When an agent step uses this prompt, its Edit panel asks what each value takes; a value the agent already has under the same name is filled in by itself.",
    highlighted: "Instructions with fill-in values highlighted",
    variableTitle: "Filled in at run time: {{name}}",
    variables: "Fill-in values:",
    noVariables: "none",
    save: "Save as a new version",
    saved: "Version {{version}} saved",
    noChange: "Change the instructions to save a new version.",
    preview: {
      title: "Preview with sample values",
      help: "Type sample values to see exactly what the model receives.",
      noInputs: "These instructions have no fill-in values.",
      valueFor: "Sample value for {{name}}",
      result: "What the model receives",
      empty: "Write instructions to see the preview.",
    },
    try: {
      title: "Try it",
      help: "Sends the preview to a model once. It is a test: counted in your usage and marked as a test.",
      model: "Model",
      run: "Try it",
      missing: "Some fill-in values are empty: {{names}}",
      failed: "The model could not answer",
      answer: "Answer",
      emptyAnswer: "(empty answer)",
      usage: "{{tokens}} tokens used",
    },
    diff: {
      title: "Compare versions",
      compare: "Compare version {{version}} with",
      with: "Version to compare with",
      caption: "Version {{left}} (left) and version {{right}} (right)",
      yours: "Your changes (from v{{version}})",
      summary_one: "{{count}} line differs.",
      summary_other: "{{count}} lines differ.",
      same: "The two versions are the same.",
      removed: "Removed:",
      added: "Added:",
    },
    issues: {
      name_invalid: "Use letters, digits, dots, hyphens and underscores.",
    },
  },
  ar: {
    intro: "التعليمات التي يستخدمها وكلاؤك. كل حفظ ينشئ إصداراً جديداً؛ اختر أي إصدار يُستخدم في التشغيل الفعلي أو الاختبار أو تجربة محدودة.",
    select: "الموجّه",
    create: "موجّه جديد",
    cancel: "إلغاء",
    newName: "اسم الموجّه الجديد",
    createHelp: "أحرف لاتينية وأرقام ونقاط وشرطات وشرطات سفلية. يُنشأ الإصدار الأول عند الحفظ.",
    nameInvalid: "استخدم أحرفاً لاتينية وأرقاماً ونقاطاً وشرطات (يبدأ بحرف أو رقم).",
    none: "لا توجد موجّهات بعد. أنشئ واحداً للبدء.",
    libraryDown: "مكتبة الموجّهات لا تعمل الآن، لذا لا يمكن عرض الموجّهات أو حفظها. اطلب من أحد المشغّلين تشغيلها (تعرض صفحة الصحة والاستخدام حالتها).",
    libraryDownTech: "ما قاله النظام",
    retry: "حاول مجدداً",
    versions: "الإصدارات",
    pick: "اختيار الإصدار {{version}}",
    pickVersion: "الإصدار {{version}}",
    pickerName: "موجّه من المكتبة",
    pickerVersion: "أي إصدار",
    pickerRef: "مرجع الموجّه المحفوظ",
    pickerDown: "تعذّر الوصول إلى مكتبة الموجّهات الآن. يمكنك كتابة مرجع الموجّه بدلًا من ذلك.",
    pickerNoVersion: "لا يوجد إصدار من هذا الموجّه مخصص لهذا الاستخدام. اختر إصدارًا آخر.",
    pickerTakes: "ما تأخذه كل قيمة",
    pickerFor: "القيمة لـ {{name}}",
    pickerChoose: "اختر قيمة من خطوة سابقة",
    pickerMissing: "ما زال مطلوبًا",
    pickerPath: "يقرأ تلك القيمة مباشرة",
    version: "الإصدار",
    usedIn: "مستخدم في",
    whatChanged: "ما الذي تغيّر؟",
    whatChangedPlaceholder: "مثلاً: الإجابات تذكر الآن بند السياسة",
    when: "التاريخ",
    useIn: "استخدام الإصدار {{version}} في:",
    stageLabel: "مكان الاستخدام",
    use: "استخدام هذا الإصدار",
    used: "أصبح الإصدار {{version}} مستخدماً في {{stage}}",
    stageHelp: "فعلي: ما يحصل عليه العملاء. اختبار: ما يجربه البناة. تجربة: حصة صغيرة من الاستخدام الفعلي.",
    stage: { live: "التشغيل الفعلي", testing: "الاختبار", trial: "التجربة المحدودة" },
    editor: "تعديل (من الإصدار {{version}})",
    firstVersion: "الإصدار الأول",
    template: "التعليمات",
    variablesHelp: "اكتب {{name}} حيث توضع قيمة، مثلاً {{customer_name}}. عندما تستخدم خطوة في وكيل هذا الموجّه، تسألك لوحة التعديل عما تأخذه كل قيمة؛ والقيمة التي لدى الوكيل بالاسم نفسه تُملأ تلقائيًا.",
    highlighted: "التعليمات مع إبراز القيم المتغيرة",
    variableTitle: "تُملأ وقت التشغيل: {{name}}",
    variables: "القيم المتغيرة:",
    noVariables: "لا توجد",
    save: "حفظ كإصدار جديد",
    saved: "تم حفظ الإصدار {{version}}",
    noChange: "غيّر التعليمات لحفظ إصدار جديد.",
    preview: {
      title: "معاينة بقيم تجريبية",
      help: "اكتب قيماً تجريبية لترى بالضبط ما يصل إلى النموذج.",
      noInputs: "لا تحتوي هذه التعليمات على قيم متغيرة.",
      valueFor: "قيمة تجريبية لـ {{name}}",
      result: "ما يصل إلى النموذج",
      empty: "اكتب التعليمات لترى المعاينة.",
    },
    try: {
      title: "جرّبه",
      help: "يرسل المعاينة إلى نموذج مرة واحدة. إنها تجربة: تُحسب في استخدامك وتُعلَّم كتجربة.",
      model: "النموذج",
      run: "جرّبه",
      missing: "بعض القيم المتغيرة فارغة: {{names}}",
      failed: "تعذر على النموذج الإجابة",
      answer: "الإجابة",
      emptyAnswer: "(إجابة فارغة)",
      usage: "استُخدم {{tokens}} رمزاً",
    },
    diff: {
      title: "مقارنة الإصدارات",
      compare: "مقارنة الإصدار {{version}} مع",
      with: "الإصدار المراد المقارنة معه",
      caption: "الإصدار {{left}} والإصدار {{right}}",
      yours: "تعديلاتك (من الإصدار {{version}})",
      summary_zero: "لا توجد أسطر مختلفة.",
      summary_one: "سطر واحد مختلف.",
      summary_two: "سطران مختلفان.",
      summary_few: "{{count}} أسطر مختلفة.",
      summary_many: "{{count}} سطراً مختلفاً.",
      summary_other: "{{count}} سطر مختلف.",
      same: "الإصداران متطابقان.",
      removed: "محذوف:",
      added: "مضاف:",
    },
    issues: {
      name_invalid: "استخدم أحرفاً لاتينية وأرقاماً ونقاطاً وشرطات.",
    },
  },
};
